import { render, staticRenderFns } from "./forsta-script-widget.vue?vue&type=template&id=d03c4fae"
import script from "./forsta-script-widget.vue?vue&type=script&lang=js"
export * from "./forsta-script-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports